export default "__VITE_ASSET__WNQ$8t98__"